import {fetchAndDeserialize} from '../../../util/api-adapter';
import {PaginationDataType} from '../../../util/pagination-hook/pagination-hook-type';
import {objectToUrlParameters} from '../../../util/url';
import {PaginatedResponseType} from '../../api/api-type';

import {
    AspectsAnalysisRequestParametersType,
    AspectsAnalysisTableRequestParametersType,
    reviewAspectRecordSchema,
    ReviewAspectRecordType,
    reviewAspectsToneDistributionSchema,
    ReviewAspectsToneDistributionType,
    reviewAspectsToneDynamicsSchema,
    ReviewAspectsToneType,
    reviewsCountByAspectsSchema,
    ReviewsCountByAspectsType,
    topAspectsItemSchema,
    TopAspectsItemType,
    TopAspectsQueryParametersType,
} from './review-aspects-type';

export function fetchReviewsAnalysisAspects(
    requestOptions: AspectsAnalysisTableRequestParametersType & PaginationDataType
): Promise<PaginatedResponseType<ReviewAspectRecordType>> {
    const {sortQueryValue, startDate, endDate, comparedStartDate, comparedEndDate, page, pageSize, filterKey} =
        requestOptions;

    return fetchAndDeserialize(
        `/v2/reviews-analytics/stats/aspects/?${objectToUrlParameters({
            sort: sortQueryValue,
            start_date: startDate,
            end_date: endDate,
            compared_start_date: comparedStartDate,
            compared_end_date: comparedEndDate,
            page,
            page_size: pageSize,
            filter_key: filterKey,
        })}`,
        reviewAspectRecordSchema
    );
}

export function fetchReviewsAnalysisAspectsTone(
    requestOptions: AspectsAnalysisRequestParametersType
): Promise<ReviewAspectsToneType> {
    const {startDate, endDate, comparedStartDate, comparedEndDate, filterKey} = requestOptions;

    return fetchAndDeserialize(
        `/v2/reviews-analytics/stats/aspects-tonality-dynamics/?${objectToUrlParameters({
            start_date: startDate,
            end_date: endDate,
            compared_start_date: comparedStartDate,
            compared_end_date: comparedEndDate,
            filter_key: filterKey,
        })}`,
        reviewAspectsToneDynamicsSchema
    );
}

export function fetchReviewsAnalysisAspectsToneDistribution(
    requestOptions: AspectsAnalysisRequestParametersType
): Promise<ReviewAspectsToneDistributionType> {
    const {startDate, endDate, comparedStartDate, comparedEndDate, filterKey} = requestOptions;

    return fetchAndDeserialize(
        `/v2/reviews-analytics/stats/aspects-tonality-distribution/?${objectToUrlParameters({
            start_date: startDate,
            end_date: endDate,
            compared_start_date: comparedStartDate,
            compared_end_date: comparedEndDate,
            filter_key: filterKey,
        })}`,
        reviewAspectsToneDistributionSchema
    );
}

export function fetchReviewsCountByAspects(
    requestOptions: AspectsAnalysisRequestParametersType
): Promise<ReviewsCountByAspectsType> {
    const {startDate, endDate, comparedStartDate, comparedEndDate, filterKey} = requestOptions;

    return fetchAndDeserialize(
        `/v2/reviews-analytics/stats/reviews-by-aspects/?${objectToUrlParameters({
            start_date: startDate,
            end_date: endDate,
            compared_start_date: comparedStartDate,
            compared_end_date: comparedEndDate,
            filter_key: filterKey,
        })}`,
        reviewsCountByAspectsSchema
    );
}

export async function fetchTopAspects(
    mainFilterKey: string,
    filterParameters: TopAspectsQueryParametersType
): Promise<Array<TopAspectsItemType>> {
    const url = `/v2/reviews-analytics/stats/top-aspects/?${objectToUrlParameters({
        filter_key: mainFilterKey,
        start_date: filterParameters.startDate,
        end_date: filterParameters.endDate,
    })}`;

    return fetchAndDeserialize<Array<TopAspectsItemType>>(url, topAspectsItemSchema.array());
}
